export const assertIsNumber = (value: string): number => {
  const valueAsNumber = Number(value);

  if (isNaN(valueAsNumber)) {
    throw new Error(`Asserted that value was a number, but it was ${value}`);
  }

  return valueAsNumber;
};

export const assertIsNumberOrNull = (value: string): number | null => {
  if (value.trim() === '') {
    return null;
  }

  return assertIsNumber(value);
};

export const addNumbersOrNull = (firstValue: number | null, secondValue: number | null): number | null => {
  if (firstValue !== null && secondValue !== null) {
    return firstValue + secondValue;
  } else if (firstValue !== null) {
    return firstValue;
  } else if (secondValue !== null) {
    return secondValue;
  } else {
    return null;
  }
};
